/** Server-built field and concept picker labels. Pure dictionary; no availability decisions. */
export const studyBuilderFieldPickerCopy = {
    hint: 'Pick a field on the left. On the right, choose what to test it as and see what shoppers are asked.',
    fieldsHeading: 'Your fields',
    valuesHeading: 'What is in this field',
    testAs: 'Test this field as',
    noConcepts: 'TestFeed cannot test this field on its own yet.',
    referenceUnavailable: 'Referenced item unavailable',
    suggested: 'Suggested',
    comingSoon: 'Coming soon',
    oneHiddenField: '1 field is hidden',
    manyHiddenFields: '{count} fields are hidden',
    hiddenFieldsAccessibilityLabel: 'Why are some fields hidden?',
    hiddenReason: "Some fields contain structured data or embedded code, sometimes added by another Shopify app (for example, a reviews widget). TestFeed can't use that content as a test option yet, so these fields are hidden.",
};
//# sourceMappingURL=study-builder-field-picker.js.map